import $ from "jquery";

$(document).ready(function() {
    console.log('navigation slideout running...');

    $(".sublink").click(function() {
        var heading = $(this).data('heading');
        var headinglink = $(this).data('headinglink');
        var linkdata = $(this).data('linkdata');
        
        // Optionally, you can do something with heading and linkdata here
        
        $("html").addClass("open_sub_menu");
        $('#submenu_title').html(heading);
        $("#submenu_title").parent().attr("href", headinglink);
        $('#link_options').html(linkdata);
    });

    $(".menu_back_button").click(function() {
        $("html").removeClass("open_sub_menu");
    });

    const menuToggle = document.getElementById('menuToggle');
    console.log("header navigation running");

    $(menuToggle).on('click', function() {
        $(this).toggleClass('active');
        var htmlEl = $('html');
        //var htmlWidth = jQuery('html').width(); // Get width of html element
        if (htmlEl.hasClass('open_menu')){
            //htmlEl.css('width', '');
            htmlEl.removeClass('open_menu');
            htmlEl.removeClass('open_sub_menu');
        } else {
            //htmlEl.width(htmlWidth);
            htmlEl.addClass('open_menu');
        }
        
    });


});